<template>
    <div class="redpacket-container-item">
        <flow-container :children="tpl.children"></flow-container>
    </div>
</template>

<script>
const {
    plugins: { ComplexComp }
} = require('@futuweb/fego-render');

export default {
    props: ['tpl'],
    mounted() {
        this.tpl.props.childSendRedpack.value = this.childSendRedpack;
    },
    components: {
        FlowContainer: ComplexComp.Container.Flow
    },
    methods: {
        childSendRedpack() {
            this.$emit('on_send_redpack');
        }
    }
};
</script>

<style lang="less" scoped>
.redpacket-container-item {
    display: flex;
    height: 100% !important;
    align-items: center;
    justify-content: center;
}
</style>
